
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {ApprovalStep} from '../../../models/approvalStep';
  import {Voucher} from "../../../models/voucherI";

  @Component({
    components: {},
  })
  export default class VoucherDetailsSignatures extends Vue {

    @Prop({default: null})
    voucher: Voucher;

    private approvalStepList: ApprovalStep[] = [];

    created() {
      //@ts-ignore
      this.approvalStepList = [...this.voucher.approvalStepList];
      //@ts-ignore
      this.approvalStepList
      //@ts-ignore
        .sort(function (a, b) {
          if (new Date(a.createDate) < new Date(b.createDate)) return -1;
          if (new Date(a.createDate) > new Date(b.createDate)) return 1;
          return 0;
        });
    }
  }
